import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ApplicationFormSectionComponent } from './application-form-section.component';
import { ApplicationFormQuestionTraverseComponent } from './application-form-question-traverse.component';
import { NavigationComponent } from './navigation/navigation.component';
import { SectionMenuComponent } from './section-menu/section-menu.component';
import { SectionMenuCAComponent } from './section-menu/section-menu-ca.component';
import { SectionRowComponent } from './section-menu/section-row/section-row.component';
import { QuestionTextComponent } from './base-components/question-text/question-text.component';
import { CustomPercentInputComponent } from './base-components/custom-percent/custom-percent-input/custom-percent-input.component';
import { DynamicComponent } from './dynamic/dynamic.component';
import { entryComponents } from './dynamic/dynamic.component';
import { NavigationCAComponent } from './navigation/navigation-ca.component';
import { SectionRowCAComponent } from './section-menu/section-row/section-row-ca.component';

//modules
import { SharedModule } from '../shared/shared.module';
import { LoadingModule } from '../shared/loading/loading.module';
import { SpinnerModule } from '../shared/spinner/spinner.module';
import { ApplicationService } from '../../services/application/application.service';
import { NavigationService } from '../../services/navigation/navigation.service';
import { PredicateService } from '../../services/predicate/predicate.service';
import { RouteChangeService } from '../../services/routes/routeChange.service';
import { GeoChangeService } from '../../services/geoChange/geoChange.service';
import { WorkflowService } from '../../services/workflow/workflow.service';
import { UnsupportedUseCasesService } from '../../services/unsupportedUseCases/unsupportedUseCases.service';
import { InformationModalService } from '../../services/informationModal/informationModal.service';
import { AMCAuth0Service } from '../../services/authentication/amc/amc-auth0.service';
import { CpButtonModule } from '../../../components/cp-button/cp-button.module';
import { ToasterModule } from '../overlays/toaster/toaster.module';
import { DesignSystemModule } from '@hit/coverpath-design-system';
import { CpPopoverModule } from '../../../components/cp-popover/cp-popover.module';

// services
import { TextMaskModule } from 'angular2-text-mask';
import { SegmentService } from '../../services/analytics/segment.service';
import { AlertModule } from '../shared/alert/alert.module';
import { PartnerApplicationFillService } from '../../../../common/angular-shared/services/application/partner-application-fill.service';
import { CheckboxModule } from '@hit/coverpath-design-system';
import { PiiService } from '../../../../common/angular-shared/services/pii.service';

export const ApplicationFormComponents = [
  ApplicationFormSectionComponent,
  ApplicationFormQuestionTraverseComponent,
  NavigationComponent,
  NavigationCAComponent,
  SectionMenuComponent,
  SectionMenuCAComponent,
  SectionRowComponent,
  SectionRowCAComponent,
];
@NgModule({
  declarations: [
    ApplicationFormComponents,
    QuestionTextComponent,
    DynamicComponent,
    CustomPercentInputComponent,
    entryComponents,
  ],
  exports: [
    ApplicationFormComponents,
    QuestionTextComponent,
    DynamicComponent,
    CustomPercentInputComponent,
    entryComponents,
  ],
  providers: [
    ApplicationService,
    NavigationService,
    RouteChangeService,
    GeoChangeService,
    WorkflowService,
    UnsupportedUseCasesService,
    InformationModalService,
    AMCAuth0Service,
    PredicateService,
    SegmentService,
    PartnerApplicationFillService,
    PiiService,
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    RouterModule,
    SharedModule,
    LoadingModule,
    SpinnerModule,
    TextMaskModule,
    CpButtonModule,
    AlertModule,
    ToasterModule,
    CheckboxModule,
    DesignSystemModule,
    CpPopoverModule,
  ],
})
export class CoverpathApplicationFormModule {}
